import { createVNode as l, mergeProps as i } from "vue";
import n from "../node_modules/@pf-ui/pf-icon-svg/es/asn/ArrowDownFilled.js";
import m from "../components/PfIcon.js";
const r = (o, e) => {
  const t = {
    ...o,
    ...e.attrs
  };
  return l(m, i(t, {
    icon: n
  }), null);
};
r.displayName = "ArrowDownFilled";
r.inheritAttrs = !1;
export {
  r as default
};
